export interface Sort {
    label: string;
    value: SortValue;
    divider?: boolean;
}

export enum SortValue {
    NewestActivity = 1,
    OldestActivity = 2,
    NewestCreated = 3,
    OldestCreated = 4,
}
